export const animationSettings = {
	x: {
		type: 'spring' as const,
		stiffness: 120,
		damping: 15,
		mass: 0.5
	}
};

export const motionVariants = {
	enter: { x: 0, transitionEnd: { x: 0 } },
	enterWithoutAnimation: {
		x: 0,
		transition: { duration: 0 },
		transitionEnd: { x: 0 }
	},
	exitSidebar: {
		x: '100%'
	},
	exitSidebarWithoutAnimation: {
		x: '100%',
		transition: { duration: 0 }
	},
	exitOverlay: { x: '-100%' }
};

export const mainVariants = {
	reset: { x: 0, transitionEnd: { x: 0 } },
	enter: { x: 0, transitionEnd: { x: 0 } },
	exit: { x: '-100%' },
	exitRight: { x: '100%' }
};
